import React from 'react';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Heart from 'lucide-react/dist/esm/icons/heart';
import Wallet from 'lucide-react/dist/esm/icons/wallet';
import './PortfolioViewSwitch.scss';
import { injectIntl } from 'react-intl';

import { withWidth } from '../../../../../utils/withWidth';

const getButtons = (intl, premiumFrequency) => [
  {
    infoType: 'Protection',
    premiumFrequency: undefined,
    icon: <Heart size={20} />,
    text: intl.formatMessage({ id: 'portf-view-c' })
  },
  {
    infoType: 'Premium',
    premiumFrequency: premiumFrequency ? premiumFrequency : 'Monthly',
    icon: <Wallet size={20} />,
    text: intl.formatMessage({ id: premiumFrequency === 'Yearly' ? 'portf-view-y' : 'portf-view-m' })
  },
  {
    infoType: 'MarketValue',
    premiumFrequency: undefined,
    icon: <Wallet size={20} />,
    text: intl.formatMessage({ id: 'portf-view-v' })
  }
];

const PortfolioViewSwitch = props => {
  const { intl, infoType, premiumFrequency, onChange, width, ...rest } = props;
  const buttons = getButtons(intl, premiumFrequency);
  const buttonHeight = width === 'xs' ? 66.66 : 100;

  const createOnChangeHandler = (buttonInfoType, buttonPremiumFrequency) => event => {
    if (infoType === 'Premium' && buttonInfoType === 'Premium') {
      onChange(buttonInfoType, buttonPremiumFrequency === 'Monthly' ? 'Yearly' : 'Monthly');
    } else {
      onChange(buttonInfoType, buttonPremiumFrequency);
    }
  };

  return (
    <div className="portfolio-view-switch" {...rest}>
      <Grid container wrap="nowrap" style={{ height: '100%' }} sx={{ flexDirection: 'column', alignItems: 'stretch' }}>
        {buttons.map((button, index) => {
          const isSelected =
            (!button.infoType || button.infoType === infoType) &&
            (!button.premiumFrequency || button.premiumFrequency === premiumFrequency);
          return (
            <Grid size={4} key={index}>
              <Button
                variant="outlined"
                onClick={createOnChangeHandler(button.infoType, button.premiumFrequency)}
                style={
                  isSelected
                    ? {
                        color: '#3966f8',
                        borderLeft: 'none',
                        borderRight: '3px solid #3966f8',
                        height: buttonHeight
                      }
                    : {
                        color: '#00000088',
                        height: buttonHeight
                      }
                }
              >
                <Grid container sx={{ flexDirection: 'column' }}>
                  <Grid>{button.icon}</Grid>
                  <Grid className="text">{button.text}</Grid>
                </Grid>
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};

export default withWidth()(injectIntl(PortfolioViewSwitch));
